import { Fragment } from "react";
import { Divider, Typography } from "@mui/material";
import SideNavLink from "components/base/SideNavLink";
import { useUserData } from "features/User";
import { usePublisherAnalytics } from "../hooks/publisher-analytics.hook";
import { useSelector } from "react-redux";

const GROUPBASELINK = '/profile/publisher-analytics';

export default function ProfileAnalyticsSideMenu() {
  const { roles } = useSelector(state => state.publisher);
  return  (
    (roles.includes("PublisherAdmin") || roles.includes("Admin")) && (
      <Fragment>
        <Divider />
        <Typography variant="h6" color="#5c6d7e" fontStyle="italic" mt={1.3}>
          Publisher Tools
        </Typography>
        <SideNavLink to={`${GROUPBASELINK}/engagement`}>
          Engagement
        </SideNavLink>
        <SideNavLink to={`${GROUPBASELINK}/comparison`}>
          Comparison
        </SideNavLink>
      </Fragment>
    )
  )
}
